import { create } from 'zustand';

import { type GenericElement } from '../lib/element';
import { clearBooleanCaches } from '../plugins/boolean';

export type ElementMap = Map<string, GenericElement>;

export interface EditorState {
  elements: ElementMap;
  selectedElementIds: string[];
  hoveredElementId: string | null;
  selectedSubElementIds: string[];
  lastUpdateHash: string;
  polygonPointsVisible: boolean;
}

export const defaultEditorStore: EditorState = {
  elements: new Map(),
  selectedElementIds: [],
  hoveredElementId: null,
  selectedSubElementIds: [],
  lastUpdateHash: '',
  polygonPointsVisible: false,
};

export function cloneEditorState(state: EditorState): EditorState {
  return {
    elements: new Map(state.elements),
    selectedElementIds: [...state.selectedElementIds],
    selectedSubElementIds: [...state.selectedSubElementIds],
    lastUpdateHash: state.lastUpdateHash,
    hoveredElementId: state.hoveredElementId,
    polygonPointsVisible: state.polygonPointsVisible,
  };
}

export const useEditorStore = create<EditorState>()(() =>
  cloneEditorState(defaultEditorStore),
);

export const resetEditorStore = () => {
  clearBooleanCaches();
  useEditorStore.setState(cloneEditorState(defaultEditorStore));
  return useEditorStore.getState();
};

export const updateEditorStore = (state: Partial<EditorState>) => {
  useEditorStore.setState(state);
  return useEditorStore.getState();
};
